// src/v2/pages/Reports/ReportHousingLoan.js
import React from 'react';
import { GeneralMessage } from '../../../common/APICommon';
import { useReportHousingLoan } from '../../hooks/useReportHousingLoan';
import { ReportHousingLoanModule } from '../../components/modules/Reports/ReportHousingLoan/ReportHousingLoanModule';

const ReportHousingLoan = ({ isHideSideMenu }) => {
  const reportHook = useReportHousingLoan();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <ReportHousingLoanModule reportHook={reportHook} />
      </div>
      <GeneralMessage form={reportHook.showMessage} message={reportHook.message} isSuccess={reportHook.isSuccess} />
    </div>
  );
};

export default ReportHousingLoan;